import { useState } from "react";
import { HbrShareIcon } from "./Mycustomsvgicons";
import { CopyAll } from "@mui/icons-material";

const ShareComponent = ({linkFromDB,watch}) => {
    const [isshare,setShare]=useState(false);

    const handleCopyLink=async(linkToCopy)=>{
        if (navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(linkToCopy);
                setShare(false);
            } catch {
                
            }
        }
  };


    return ( 
        <div style={{position:"relative"}}>
        <button style={{border:'none',fontWeight:"bold",backgroundColor:"#efefef",cursor:"pointer"}}
                onClick={()=>setShare(prev => !prev)}>
            Share <HbrShareIcon width="1.6em" height="1.6em" fillColour="black"/>
        </button>

        {isshare &&
            <div className='flex-spacebetween' style={{
                position:"absolute",
                width:"220px",
                padding:"10px",
                top:"100%",
                left:"0px",
                zIndex:"1",
                paddingRight:"1em",
                boxSizing:"border-box",
                backgroundColor:"white",
                boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23",
                borderRadius:"10px"}}>
                    <div className='flex-row2' style={{width:"70%",overflow:"hidden"}}>
                    <pre>{`${linkFromDB}hbrlive?watch=${watch}`}</pre>
                    </div>
               
                <button style={{
                    backgroundColor:"transparent",
                    cursor:"pointer",
                    border:"none"
                }} onClick={()=>handleCopyLink(`${linkFromDB}${watch && watch.replace(/ /g,"%20")}`)}>
                    Copy <CopyAll/>
                </button>
            </div>
        }
        </div> 
        );
}
 
export default ShareComponent;